/**
 * 小程序多环境 API 域名配置
 *
 * 宿主 wld-uniapp 通过 uni.getAccountInfoSync() 获取小程序环境版本，
 * 以 URL 参数 ?envVersion= 传入 H5 webview。
 * H5 读取该参数自动匹配对应后端域名，无需重新打包。
 *
 * 环境版本说明（uni-app 官方）：
 *   develop  — 开发版（开发者扫码打开）
 *   trial    — 体验版
 *   release  — 正式版
 *
 * 修改下方 API_MAP 中对应环境的域名即可。
 */

const API_MAP = {
  develop: 'https://vpai-dev.jiuyebao.cn',
  trial:   'https://vpai-test.jiuyebao.cn',
  release: 'https://vpai.jiuyebao.cn'
}

/**
 * 从 URL 参数获取宿主传入的小程序环境版本
 * @returns {'develop' | 'trial' | 'release' | null}
 */
export function getMiniProgramEnv() {
  try {
    const params = new URLSearchParams(window.location.search)
    const envVersion = params.get('envVersion')
    if (envVersion) {
      console.log('[env] 当前小程序环境版本:', envVersion)
      return envVersion
    }
  } catch (e) {
    console.warn('[env] 读取 URL 参数 envVersion 失败:', e.message || e)
  }
  return null
}

/**
 * 根据小程序环境获取对应的 API 域名
 * @returns {string} API 域名
 */
export function getApiBaseUrl() {
  const env = getMiniProgramEnv()
  if (env && API_MAP[env]) {
    console.log('[env] 使用 API 域名:', API_MAP[env])
    return API_MAP[env]
  }
  // 非小程序环境（独立 H5）或获取失败时，回退到构建时的环境变量
  console.log('[env] 非小程序环境，使用默认域名')
  return null
}

export default API_MAP
